import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import BrushMark from "@/components/BrushMark";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    // AuthContext expects (email, password); pass the username in that slot
    // so backend (real auth) and static-api (demo auth) both work unchanged.
    const res = await login(username.trim(), password);
    setBusy(false);
    if (res.ok) {
      toast.success("Signed in.");
      nav("/admin");
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-warmwhite flex flex-col" data-testid="admin-login-page">
      <header className="px-8 py-6 hairline-bottom">
        <BrushMark size={56} />
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
          <p className="overline text-graphite/55">Admin</p>
          <h1 className="mt-4 h-display text-4xl">Sign in.</h1>
          <p className="mt-3 text-graphite/65 text-sm">For the editorial team of Carlton Elleker Chase.</p>

          <div className="mt-12 space-y-8">
            <div>
              <label className="overline text-graphite/55">Username</label>
              <input
                data-testid="admin-username"
                className="edit-input"
                type="text"
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck="false"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div>
              <label className="overline text-graphite/55">Password</label>
              <input
                data-testid="admin-password"
                className="edit-input"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {err && <p className="mt-6 text-sm text-red-700" data-testid="admin-login-error">{err}</p>}

          <button type="submit" disabled={busy} className="cec-btn cec-btn-primary mt-10" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </main>
    </div>
  );
}
